module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-privacy-policies"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('h4', [_vm._v("Privacy")]), _vm._v(" "), _c('p', [_vm._v("\n          We don't store or use or care about using any personal data or personal information about you or any\n          other visitors ... The only analytics tool used on these pages is "), _c('a', {
    attrs: {
      "href": "https://usage.foobar.beer"
    }
  }, [_vm._v("webalizer + access log")]), _vm._v(".\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('h4', [_vm._v("License")]), _vm._v(" "), _c('p', [_vm._v("\n          All the content on this site is available under "), _c('a', {
    attrs: {
      "href": "http://wtfpl.net"
    }
  }, [_vm._v("WTFPL")]), _vm._v(".\n        ")]), _vm._v(" "), _c('pre', [_vm._v("          DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE\n          Version 2, December 2004\n\n          Copyright (C) 2004 Sam Hocevar <sam@hocevar.net>\n\n          Everyone is permitted to copy and distribute verbatim or modified\n          copies of this license document, and changing it is allowed as long\n          as the name is changed.\n\n                DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE\n          TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION\n\n          0. You just DO WHAT THE FUCK YOU WANT TO.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f38608c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/privacy/PrivacyPolicies.vue
// module id = 1840
// module chunks = 1